import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

const BreadCrumbs = (props: any) => {
  const router = useRouter();
  const [breadcrumbs, setBreadcrumbs] = useState<any>([]);
  const [lastCrumb, setLastCrumb] = useState<any>([]);
  const [offerPageName, setOfferPageName] = useState('');
  const { locale } = useRouter();
  let last: any = [];

  const evaluateBreadCrumb = (value: any) => {
    const breadCrumbValue = value && value[0] && value[0].href;

    switch (true) {
      case (breadCrumbValue?.includes('portable-storage') &&
        breadCrumbValue?.includes('residential')) ||
        (breadCrumbValue?.includes('entreposage-mobile') &&
          breadCrumbValue?.includes('residentiel')):
        if (locale === 'en') {
          last[0].label = 'Residential Portable Storage';
        } else {
          last[0].label = 'Entreposage mobile résidentiel';
        }
        setLastCrumb((val: any) => {
          return { ...val, label: last[0].label };
        });

        break;
      case (breadCrumbValue?.includes('portable-storage') &&
        breadCrumbValue?.includes('business')) ||
        (breadCrumbValue?.includes('entreposage-mobile') &&
          breadCrumbValue?.includes('commercial')):
        if (locale === 'en') {
          last[0].label = 'Portable Storage Containers for Business';
        } else {
          last[0].label = 'Conteneurs mobiles pour entreposage commercial';
        }
        setLastCrumb((val: any) => {
          return { ...val, label: last[0].label };
        });
        break;
      case breadCrumbValue &&
        (breadCrumbValue === '/portable-storage/moving' ||
          breadCrumbValue === '/entreposage-mobile/demenagement'):
        if (locale === 'en') {
          last[0].label = 'Portable Storage for Moving';
        } else {
          last[0].label = 'Entreposage mobile pour déménager';
        }
        setLastCrumb((val: any) => {
          return { ...val, label: last[0].label };
        });
        break;
      case (breadCrumbValue?.includes('portable-storage') &&
        breadCrumbValue?.includes('long-distance-moving')) ||
        (breadCrumbValue?.includes('entreposage-mobile') &&
          breadCrumbValue?.includes('demenagement-longue-distance')):
        if (locale === 'en') {
          last[0].label = 'Long Distance Moving';
        } else {
          last[0].label = 'Déménagement sur longue distance';
        }
        setLastCrumb((val: any) => {
          return { ...val, label: last[0].label };
        });
        break;
      case breadCrumbValue &&
        (breadCrumbValue === '/packing-supplies' ||
          breadCrumbValue === '/fournitures-emballage'):
        if (locale === 'en') {
          last[0].label = 'Packing Supplies';
        } else {
          last[0].label = "Fournitures de déménagement et d'emballage";
        }
        setLastCrumb((val: any) => {
          return { ...val, label: last[0].label };
        });
        break;
      case breadCrumbValue &&
        (breadCrumbValue === '/self-storage/business' ||
          breadCrumbValue === '/entreposage-libre-service/commercial'):
        if (locale === 'en') {
          last[0].label = 'Business Self Storage';
        } else {
          last[0].label = 'Entreposage commercial en libre-service';
        }
        setLastCrumb((val: any) => {
          return { ...val, label: last[0].label };
        });
        break;
      case breadCrumbValue &&
        (breadCrumbValue === '/self-storage/moving' ||
          breadCrumbValue === '/entreposage-libre-service/demenagement'):
        if (locale === 'en') {
          last[0].label = 'Moving Storage';
        } else {
          last[0].label = 'Entreposage mobile';
        }
        setLastCrumb((val: any) => {
          return { ...val, label: last[0].label };
        });
        break;
      case breadCrumbValue &&
        (breadCrumbValue === '/terms-of-service' ||
          breadCrumbValue === '/conditions-dutilisation'):
        if (locale === 'en') {
          last[0].label = 'User Agreement';
        } else {
          last[0].label = 'ENTENTE SUR LES CONDITIONS D’UTILISATION';
        }
        setLastCrumb((val: any) => {
          return { ...val, label: last[0].label };
        });
        break;
      case breadCrumbValue &&
        (breadCrumbValue === '/careers' || breadCrumbValue === '/carrieres'):
        if (locale === 'en') {
          last[0].label = 'Careers';
        } else {
          last[0].label = 'Carrieres';
        }
        setLastCrumb((val: any) => {
          return { ...val, label: last[0].label };
        });
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    const pageName =
      typeof window !== 'undefined' && window.location.pathname.split('/');

    let pathWithoutQuery;
    if (
      pageName[2] === 'offers' ||
      pageName[2] === 'offres' ||
      pageName[2] === 'blogue' ||
      pageName[2] === 'blog'
    ) {
      setOfferPageName(pageName[2]);
      pathWithoutQuery = `/${pageName[2]}/${pageName[3]}`;
    } else {
      pathWithoutQuery =
        locale === 'en'
          ? props.path
          : typeof window !== 'undefined' &&
            window.location.href.split('fr')[1];
    }
    pathWithoutQuery = pathWithoutQuery?.replace('#form', '');
    let pathArray = pathWithoutQuery?.split('/');
    if (locale === 'en') {
      pathArray.shift();
    }
    pathArray = pathArray?.filter(
      (path: any) => path !== '' && !path.startsWith('?')
    );

    const breadcrumb = pathArray?.map((path: any, index: any) => {
      return {
        href: `/${pathArray.slice(0, index + 1).join('/')}`,
        label: path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, ' '),
      };
    });
    last = breadcrumb.slice(-1);
    setLastCrumb(last);
    breadcrumb.splice(breadcrumb.length - 1, 1);

    setBreadcrumbs(breadcrumb);
    evaluateBreadCrumb(last);
  }, [
    router.asPath,
    locale,
    typeof window !== 'undefined' && window.location.href,
  ]);

  return (
    <>
      <div
        className={
          props.isNoMargin ? 'container container-no-margin' : 'container'
        }
      >
        <Breadcrumb className="sv-breadcrumb">
          {locale === 'en' && <Breadcrumb.Item href="/">Home</Breadcrumb.Item>}
          {locale === 'fr' && (
            <Breadcrumb.Item href="/fr/">Accueil</Breadcrumb.Item>
          )}
          {offerPageName !== 'offers' &&
            offerPageName !== 'offres' &&
            offerPageName !== 'blogue' &&
            offerPageName !== 'blog' &&
            breadcrumbs &&
            breadcrumbs.map((breadcrumb: any) =>
              breadcrumb?.label === 'Self storage' ||
              breadcrumb?.label === 'Entreposage libre service' ? (
                <Breadcrumb.Item
                  key={breadcrumb?.href}
                  href={
                    locale === 'en'
                      ? `/en${breadcrumb?.href}/`
                      : `/fr${breadcrumb?.href}/`
                  }
                  className="breadcrumbs"
                >
                  {breadcrumb?.label}
                </Breadcrumb.Item>
              ) : (
                <Breadcrumb.Item
                  active
                  key={breadcrumb?.href}
                  href={`${breadcrumb?.href}/`}
                  className="breadcrumbs"
                >
                  {breadcrumb?.label}
                </Breadcrumb.Item>
              )
            )}
          {offerPageName && offerPageName.length && (
            <Breadcrumb.Item
              href={
                locale === 'en'
                  ? `/en/${offerPageName}/`
                  : `/fr/${offerPageName}/`
              }
            >
              {offerPageName}
            </Breadcrumb.Item>
          )}
          <Breadcrumb.Item active>{lastCrumb[0]?.label}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
    </>
  );
};

export default BreadCrumbs;
